
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  Attachment, AttachmentType,
  DataTableHeaderOptions,
  PermissionCode,
} from '@/types';
import AttachmentTypeComponent from '@/components/AttachmentType.vue';
import AttachmentDate from '@/components/AttachmentDate.vue';
import AttachmentSize from '@/components/AttachmentSize.vue';
import AttachmentsGallery from '@/components/AttachmentsGallery.vue';
import { currentUserHasPermission, currentUserIsSuper } from '@/helpers';

@Component({
  components: {
    AttachmentTypeComponent,
    AttachmentDate,
    AttachmentSize,
    AttachmentsGallery,
  },
})
export default class AttachmentSelectDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  // La tipologia di allegato a cui verrano aggiunti gli allegati selezionati
  @Prop({ type: String, default: 'altri' }) readonly type!: AttachmentType

  // Se true, l'aggiornamento è immediato
  @Prop({ type: Boolean, default: false }) readonly updateNow!: boolean

  // Consente la selezione di un allegato esistente dei tipi selezionati
  @Prop({ type: Array, default: () => [] }) readonly selectFrom!: AttachmentType[]

  // Se true, è utilizzato all'interno di una Connection
  @Prop({ type: Boolean, default: false }) readonly connection!: boolean

  dialog = false
  loading = false

  headers: DataTableHeaderOptions[] = [
    {
      text: '',
      value: 'attachment',
      align: 'start',
      sortable: false,
    },
    {
      text: '',
      value: 'actions',
      align: 'start',
      sortable: false,
    },
  ]

  selectedAttachments: Attachment[] = []

  selected: Attachment | null = null
  galleryDialog = false

  @Watch('value')
  onValueChange(val: boolean) {
    console.log(`${this.constructor.name}: onValueChange()`); // eslint-disable-line no-console

    if (val === true) {
      this.selectedAttachments = [];
    }
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get isSuper(): boolean { return currentUserIsSuper(); }

  // Tutti gli allegati associati alla Lead e alle sue eventuali figlie
  get attachments(): Attachment[] {
    return this.$store.getters.currentLeadAttachments;
  }

  // Tutti gli allegati associati alla Lead e alla Lead "padre"
  // appartenenti ad uno dei tipi specificati in `selectFrom`
  get availableAttachments(): Attachment[] {
    return this.attachments
      .filter((attachment: Attachment) => this.selectFrom.includes(attachment.fieldname));
  }

  // get noAttachments() {
  //   return !this.filteredAttachments
  //     || (Array.isArray(this.filteredAttachments) && this.filteredAttachments.length === 0);
  // }

  get filteredAttachments() {
    const attachmentList: Attachment[] = [...this.availableAttachments];

    const uniqueAttachmentList = attachmentList
      .reduce((uniqueAttachments: Attachment[], currentAttachment: Attachment) => {
        const existingAttachment = uniqueAttachments
          .find((attachment) => attachment.id === currentAttachment.id);

        if (!existingAttachment) {
          uniqueAttachments.push(currentAttachment);
        }

        return uniqueAttachments;
      }, []);

    return uniqueAttachmentList.filter((a: Attachment) => {
      // Nasconde gli alleggati che l'utente non può visualizzare
      if (!this.hasPermission(`attachments.${a.fieldname}.read`)) return false;

      // Nasconde gli allegati già selezionati
      if (this.currentUpdateSelectedAttachmentsIds.includes(a.id)) return false;

      return true;
    });
  }

  // L'elenco degli `id` degli allegati attualmente selezionati
  // ma non ancora confermati.
  get currentUpdateSelectedAttachmentsIds(): number[] {
    const currentUpdate = this.connection
      ? this.$store.getters.currentConnectionUpdate
      : this.$store.getters.selectedLeadUpdate;

    return currentUpdate?.selectedAttachments
      ? currentUpdate?.selectedAttachments.map((a) => a.id) as []
      : [];
  }

  hasPermission(codename: PermissionCode) { return currentUserHasPermission(codename); }

  onView(attachment: Attachment) {
    this.selected = attachment;
    this.galleryDialog = true;
  }

  onSelectAttachment(attachment: Attachment, selected: boolean) {
    console.log(`${this.constructor.name}: onSelectAttachment()`); // eslint-disable-line no-console

    if (selected) {
      this.selectedAttachments.push(attachment);
    } else {
      this.selectedAttachments = this.selectedAttachments.filter((a) => a.id !== attachment.id);
    }
  }

  async onCancel() {
    console.log(`${this.constructor.name}: onCancel()`); // eslint-disable-line no-console

    this.loading = true;

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  async onSelect() {
    console.log(`${this.constructor.name}: onSelect()`); // eslint-disable-line no-console

    this.loading = true;

    if (this.updateNow === false) {
      // Comunica ad AttachmentsList l'elenco dei nuovi allegati
      // (si occuperà lui eventualmente di aggiungerli al task/lead)
      this.$emit('select', this.selectedAttachments);
    } else {
      // TODO: Aggiunge direttamente gli allegati (aggiornamento immediato)

      // await this.$store.dispatch('updateLead', {
      //   updateType: 'attachments',
      //   update: {
      //     attachments: this.selectedAttachments.map((a) => a.id),
      //   },
      // });
    }

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
